import { render, staticRenderFns } from "./vc-tooltip.vue?vue&type=template&id=1ce1caf6&scoped=true&"
import script from "./vc-tooltip.vue?vue&type=script&lang=js&"
export * from "./vc-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./vc-tooltip.vue?vue&type=style&index=0&id=1ce1caf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1caf6",
  null
  
)

export default component.exports